
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Dashboard from "./Pages/Dashboard";
import QRCodes from "./Pages/QRCodes";
import Users from "./Pages/Users";
import Analytics from "./Pages/Analytics";
import Settings from "./Pages/Settings";
import Create from "./Pages/Create";
import RequestForm from "./Pages/RequestForm.jsx";  
import Login from "./Pages/Adminlogin.jsx";
import Requests from "./Pages/Requests.jsx";
import PrivacyPolicy from "./Pages/privacypolicy.jsx";
import TermsOfUse from "./Pages/terms.jsx";
import RegisterQR from "./Pages/RegisterOrRedirect.jsx";
import UserLogin from "./Pages/UserLogin.jsx";
import EditRegistration from "./Pages/EditRegistration.jsx";
import GalleryViewer from "./Pages/GalleryViewer.jsx";
function App() {
  return (
    <Router>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route path="/:qrId" element={<RegisterQR />} />
        <Route path="/" element={<UserLogin />} />
        <Route path="/login" element={<UserLogin />} />
         <Route path="/gallery/:qrId" element={<GalleryViewer />} />
         <Route path="/edit-registration" element={<EditRegistration />} />
        <Route path="/requestform" element={<RequestForm />} />
        <Route path ="/access" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/qrcodes" element={<QRCodes />} />
        <Route path="/users" element={<Users />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/create" element={<Create />} />
        <Route path="/requests" element={<Requests />} />
         <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />  
      </Routes>
    </Router>
  );
}

export default App;

